import { defineStore } from "pinia";
import { fetchCampaignData, listReferrers } from "@/api/campaign";

export const campaignStore = defineStore("campaign", {
    state: () => ({
        campaigns: [],
        campaign: null,
        referrers: [],
        currentCampaign: null
    }),

    actions: {
        async loadCampaigns() {
            const res = await fetchCampaignData()
            const campaigns = res.data.data
            this.campaigns= Array.isArray(campaigns)
                ? campaigns
                : [campaigns]
        },
        async showReferrers(campaignUuid) {
            try {
                    const res = await listReferrers(campaignUuid)

                    console.log(res.data.data.data)

                    const referrers = res.data.data.data

                    this.referrers = Array.isArray(referrers)
                        ? referrers
                        : [referrers]

                    this.currentCampaign = res.data.campaign ?? null

                } catch (error) {
                    console.error(error)
            }
        }
    }
});